module.exports = __webpack_public_path__ + "img/game-detail-icon.png";